import { render, staticRenderFns } from "./Impact.vue?vue&type=template&id=6acfa65e&scoped=true"
import script from "./Impact.vue?vue&type=script&setup=true&lang=ts"
export * from "./Impact.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Impact.vue?vue&type=style&index=0&id=6acfa65e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acfa65e",
  null
  
)

export default component.exports